import axios from '@/axios'
import * as types from '../mutation-types';

export default {
	namespaced: true,

	state: {
		statistics: [],
		providerStatistics: [],
		itemsStatistics: []
	},

	actions: {
		fetchAll({ commit }, { fromDate, toDate, forClient }) {
			return axios.get('/statistics', {
				params: { fromDate, toDate, forClient }
			}).then((data) => {
				commit(types.STORE_PROVIDER_STATISTICS, data);
				return data;
			})
		},

		fetchProviderStatistics({ commit }, { fromDate, toDate, forClient }) {
			return axios.get('/statistics/provider', {
				params: { fromDate, toDate, forClient }
			}).then((data) => {
				commit(types.STORE_PROVIDER_STATISTICS, data);
				return data;
			})
		},

		fetchItemStatistics({ commit }) {
			return axios.get('/Statistics/Dashboard').then((data) => {
				commit(types.STORE_ITEMS_STATISTICS, data)
				return data
			})
		},

		fetchAvailableToSellQuantities({ commit }) {
			return axios.get('/Statistics/AvailableToSellQuantities').then((data) => {
				return data
			})
		},
	},

	mutations: {
		[types.STORE_STATISTICS](state, statistics) {
			state.statistics = statistics;
		},
		[types.STORE_PROVIDER_STATISTICS](state, providerStatistics) {
			state.providerStatistics = providerStatistics;
		},
		[types.STORE_ITEMS_STATISTICS](state, itemsStatistics) {
			state.itemsStatistics = itemsStatistics
		}
	},
}